import OutpatientBenefitsStep from "components/steps/OutpatientBenefitsStep";

const Step5Pages = () => <OutpatientBenefitsStep />;

export default Step5Pages;
